import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body py-4 px-0" }
const _hoisted_3 = { class: "default-table-area style-two all-projects" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "ID"),
                _createElementVNode("th", { scope: "col" }, "Ticket Title"),
                _createElementVNode("th", { scope: "col" }, "Requester"),
                _createElementVNode("th", { scope: "col" }, "Assigned To"),
                _createElementVNode("th", { scope: "col" }, "Created Date"),
                _createElementVNode("th", { scope: "col" }, "Due Date"),
                _createElementVNode("th", { scope: "col" }, "Priority"),
                _createElementVNode("th", { scope: "col" }, "Status"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[1] || (_cache[1] = _createElementVNode("td", { class: "text-body" }, "#854", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/help-desk/ticket-details",
                    class: "fw-medium"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createTextVNode(" Network Infrastructure ")
                    ])),
                    _: 1
                  })
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("td", { class: "text-secondary" }, "Walter Frazier", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("td", { class: "text-secondary" }, "Oliver Clark", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("td", { class: "text-secondary" }, "20 Apr 2024", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("td", { class: "text-secondary" }, "30 Apr 2024", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("td", { class: "text-secondary" }, "High", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-primary bg-opacity-10 text-primary p-2 fs-12 fw-normal" }, " Finished ")
                ], -1)),
                _cache[8] || (_cache[8] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center gap-3" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " visibility ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " edit ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ")
                    ])
                  ])
                ], -1))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}